
define('text!modules/reporting/campaigns/contextual/templates/grid.html',[],function () { return '<div class="contextual-grid-container"></div>\n';});

